"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storybook_1 = require("@eyecons/storybook");
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
function Create(_a) {
    var comments = _a.comments, setComments = _a.setComments, user = _a.user, video = _a.video;
    var _b = ra_fetch_1.useApi('media')
        .records(setComments, comments.data)
        .store('comments', {
        name: user.name,
        text: '',
        user_id: user.id,
    }), comment = _b[0], setComment = _b[1], submitComment = _b[2];
    function onSubmit() {
        submitComment({ video_id: video.external_id }).then(function (res) {
            if (!res.errors.length) {
                setComment({ text: '' });
            }
        });
    }
    return react_1.default.createElement("div", { className: 'storybook-comments-form' },
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Texts.Heading, { className: 'mb-xs', type: 'h4' }, "Reactie toevoegen"),
            !user.id && react_1.default.createElement(storybook_1.Buttons.Link, { icon: 'user', to: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/login/?return=/videos/" + video.slug, responsive: false, type: 'primary' }, "Login"),
            user.id && react_1.default.createElement("div", { className: 'storybook-comments-form-input' },
                react_1.default.createElement(storybook_1.Forms.Input, { value: comment.data.text, type: 'text', onChange: function (text) { return setComment({ text: text }); } }),
                react_1.default.createElement(storybook_1.Forms.Buttons, { className: 'justify-start', errors: comment.errors, oading: comment.submittting, submit: onSubmit, title: 'Reageren' }))));
}
exports.default = Create;
